import axios from "axios";

// API Base URL - can be configured via environment variable
// Default: /apiv2 (nginx reverse proxy ile api.therapoloji.freelancer.ist'e yönlendirilir)
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/apiv2";

// Image/Uploads Base URL - can be configured via environment variable
// Default: https://panel.therapoloji.freelancer.ist/uploads
export const UPLOADS_BASE_URL = process.env.REACT_APP_UPLOADS_BASE_URL || "https://panel.therapoloji.freelancer.ist/uploads";

export const buildApiUrl = (path: string) => {
  return `${API_BASE_URL}${path}`;
};

export const buildImageUrl = (imagePath: string) => {
  return `${UPLOADS_BASE_URL}/${imagePath}`;
};

export const apiClient = axios.create({
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});
